import { Box, Container, Divider, Typography } from '@mui/material'
import HeaderSession from '../../../utils/headerSession'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../services/api'
import TextFormatado from '../../../utils/TextFormatado'
import Date from '../../../utils/date'
import Loading from '../../../load/loading'
import RegisterAccess from '../../../utils/registerAccess'

export default function ViewNoticia({ preview, criacao }) {
    const { id } = useParams()
    const [noticia, setNoticia] = useState(preview)
    const [noticias, setNoticias] = useState('')

    useEffect(() => {
        if (!preview) {
            api.get(`/noticia/${id}`)
                .then(response => {
                    // console.log(response)
                    setNoticia(response.data.noticia);
                }).catch(error => {
                    // console.log(error)
                })

            api.get(`/noticias?seccao=Notícia`)
                .then(response => {
                    // console.log(response)
                    setNoticias(response.data.noticias.filter((noticia) => noticia._id !== id));
                }).catch(error => {
                    // console.log(error)
                })
        }
    }, [id, preview])

    const CardNoticia = ({ noticia }) => {
        return (
            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', borderRadius: '4px', mb: 2, position: 'relative' }}>
                <br/>
                <Typography variant="subtitle1" style={{ lineHeight: 1.3, fontSize: 20, margin: 10 }}>
                    <strong> {noticia.titulo} </strong>
                </Typography>
                <Typography variant="subtitle2" style={{ lineHeight: 1, fontSize: 15, margin: 10 }}>
                    <strong> {noticia?.subTitulo} </strong>
                </Typography>

                <br />
                {criacao ?
                    <img src={URL.createObjectURL(noticia?.imagem)} alt="..." width={'100%'} style={{ marginBottom: 5 }} />
                    :
                    <img src={noticia?.imagem} alt="..." width={'100%'} style={{ marginBottom: 5 }} />
                }

                {noticia?.categoria &&
                    <Typography style={{ color: '#fff', marginBottom: 10, background: '#85287e', display: 'inline-block', padding: 3, margin: 10, borderRadius: 2 }}>
                        <span translate="no">{noticia.categoria}</span>
                    </Typography>
                }
                <Typography variant="subtitle2" style={{ lineHeight: 1, margin: 10 }}>
                    Data: <Date date={noticia.updatedAt} />
                    <br />
                    Fonte: <span translate="no">{noticia.fonte}</span>
                    {(noticia[id]?.link && noticia.fonte !== 'ARMED') &&
                        <a target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }} href={noticia.link}> Clique aquí para visitar </a>
                    }
                </Typography>

                <Box sx={{ margin: 1 }}>
                    <TextFormatado texto={noticia?.conteudo} /> 
                </Box>

                <br />
                <Divider style={{ marginBottom: 30 }} />
            </Box>
        );
    };

    return (
        <Container style={{ maxWidth: 800, minHeight: '70vh' }}>
            <RegisterAccess page={'visualizar noticia'} />
            {!preview && <HeaderSession title='NOTÍCIAS' />}

            {noticia ?
                <>
                    {/* INPUT PARA DAR FOCO NO COMPONENTE ASSIM QUE FOR EXIBIDO */}
                    <input autoFocus type="text" style={{ opacity: 0, height: 1 }} />
                    <CardNoticia noticia={noticia} />
                </>
                :
                <Loading />
            }

            {noticias &&
                <>
                    <Typography variant="h1" style={{ color: '#a0a39e', lineHeight: 1, fontSize: 30, marginTop: 40, marginBottom: 20 }}>
                        <strong >Outras Notícias </strong>
                    </Typography>

                    {noticias.map((noticia) => (
                        // noticia.status === "Activo" &&
                        <CardNoticia key={noticia._id} noticia={noticia} />
                    ))}
                </>
            }
            <br />
        </Container>
    )
}
